/* INNOR — fiche produit : carrousel de la galerie photo.

   Retour du 11 août : les photos empilées verticalement se lisaient comme
   un défilé de page, pas comme une fiche produit. Une image à la fois dans
   un cadre de ratio fixe, flèches + bande de vignettes pour choisir, swipe
   tactile. Le viewer 3D (pdp__3d, innor-pdp3d.js) reste un bloc à part au-
   dessus : ce fichier ne pilote que les photos. */
(function () {
  'use strict';

  function bind(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.carousel__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.carousel__thumb'));
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var count = root.querySelector('[data-carousel-count]');
    var viewport = root.querySelector('.carousel__viewport');
    var total = slides.length;
    var current = 0;

    function goto(index) {
      current = (index + total) % total;
      slides.forEach(function (slide, i) {
        slide.hidden = i !== current;
        if (i === current) slide.setAttribute('data-active', ''); else slide.removeAttribute('data-active');
      });
      thumbs.forEach(function (thumb, i) {
        if (i === current) {
          thumb.setAttribute('data-active', '');
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('data-active');
          thumb.removeAttribute('aria-current');
        }
      });
      if (count) count.textContent = (current + 1) + ' / ' + total;
      lireVideos();
    }

    /* Vidéos de la galerie (30/09/2026) : lues seulement quand elles sont
       visibles à l'écran, en pause sinon. Sur mobile une seule diapositive est
       affichée (les autres sont hidden, donc jamais visibles) ; sur PC elles
       sont en grille et se lancent au défilement. */
    var videos = slides.filter(function (s) { return s.tagName === 'VIDEO'; });
    var visibles = new Set();
    function lireVideos() {
      videos.forEach(function (v) {
        var aLEcran = visibles.has(v) && getComputedStyle(v).display !== 'none';
        if (aLEcran) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }
    if (videos.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) {
            /* L'affiche n'est posée qu'au moment où la vidéo est vue (voir
               main-product.liquid) : elle ne pèse rien tant qu'on ne l'atteint pas. */
            if (e.target.dataset.poster) { e.target.poster = e.target.dataset.poster; e.target.removeAttribute('data-poster'); }
            visibles.add(e.target);
          } else visibles.delete(e.target);
        });
        lireVideos();
      }, { threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    }

    if (prev) prev.addEventListener('click', function () { goto(current - 1); });
    if (next) next.addEventListener('click', function () { goto(current + 1); });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goto(i); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goto(current - 1);
      if (e.key === 'ArrowRight') goto(current + 1);
    });

    // Swipe tactile : seuil de 40px pour ne pas déclencher sur un simple tap.
    if (viewport) {
      var startX = null;
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goto(dx < 0 ? current + 1 : current - 1);
        startX = null;
      }, { passive: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-carousel]').forEach(bind);
  });
})();
